var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm._m(0);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "picture-text area"
  }, [_c("div", {
    staticClass: "part left clearfix"
  }, [_c("img", {
    attrs: {
      src: require("@/assets/images/service/institutional-trading/pbtrade_product_4.png"),
      alt: ""
    }
  }), _c("div", {
    staticClass: "contents"
  }, [_c("div", {
    staticClass: "title puhui-M"
  }, [_vm._v("狙击涨停，打板志在必得")]), _c("div", {
    staticClass: "info"
  }, [_vm._v("Level2逐笔数据实时推送，个股涨停快人3秒，抢单排队领先他人。")])])]), _c("div", {
    staticClass: "part right clearfix"
  }, [_c("img", {
    attrs: {
      src: require("@/assets/images/service/institutional-trading/pbtrade_product_5.png"),
      alt: ""
    }
  }), _c("div", {
    staticClass: "contents"
  }, [_c("div", {
    staticClass: "title puhui-M"
  }, [_vm._v("狙击涨停，打板志在必得")]), _c("div", {
    staticClass: "info"
  }, [_vm._v("Level2逐笔数据实时推送，个股涨停快人3秒，抢单排队领先他人。")])])]), _c("div", {
    staticClass: "part left clearfix"
  }, [_c("img", {
    attrs: {
      src: require("@/assets/images/service/institutional-trading/pbtrade_product_6.png"),
      alt: ""
    }
  }), _c("div", {
    staticClass: "contents"
  }, [_c("div", {
    staticClass: "title puhui-M"
  }, [_vm._v("狙击涨停，打板志在必得")]), _c("div", {
    staticClass: "info"
  }, [_vm._v("Level2逐笔数据实时推送，个股涨停快人3秒，抢单排队领先他人。")])])])]);
}];
render._withStripped = true;
export { render, staticRenderFns };